import { useState } from "react";
import { useNavigate } from "react-router-dom";
import type { IdentificationDocumentListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { AppRouting } from "web_myplann/Infrastructure/Utils/UrlUtils";
import type { PaperworkDocType } from "web_myplann/Profile/Constants/paperworkDocTypes";
import { usePaperworkDocumentForm } from "web_myplann/Profile/Hooks/usePaperworkDocumentForm";

type PaperworkAddStep = "form" | "success";

export const usePaperworkAddFlow = (
	type: PaperworkDocType,
	document?: IdentificationDocumentListItemResponseDTO,
) => {
	const navigate = useNavigate();
	const isUpdate = document != null;
	const [step, setStep] = useState<PaperworkAddStep>("form");
	const [reminderSet, setReminderSet] = useState(false);
	const documentForm = usePaperworkDocumentForm(type, document);

	const exit = () =>
		navigate(
			document
				? AppRouting.MyPlann.Profile.PaperworkDetail.path(document.id)
				: AppRouting.MyPlann.Profile.Paperwork.path(),
		);
	const backToTypeList = () =>
		navigate(
			document
				? AppRouting.MyPlann.Profile.PaperworkEdit.path(document.id)
				: AppRouting.MyPlann.Profile.PaperworkAdd.path(),
		);

	return {
		step,
		reminderSet,
		isUpdate,
		documentForm,
		submitForm: (result: { reminderSet: boolean }) => {
			setReminderSet(result.reminderSet);
			setStep("success");
		},
		goBack: () => {
			if (documentForm.isSubmitting) return;

			navigate(AppRouting.MyPlann.Profile.Paperwork.path());
		},
		addAnother: backToTypeList,
		exit,
	};
};
